import { Injectable, inject } from '@angular/core';
import { SocketService } from './socket.service';
import { AuthService } from './auth.service';
import { SessionModalService } from './session-modal.service';
import { SessionEvent } from '../models/auth.model';
import { filter } from 'rxjs';
import { ToastService } from '../../shared/services/toast.service';

@Injectable({
    providedIn: 'root'
})
export class SessionService {
    private socketService = inject(SocketService);
    private authService = inject(AuthService);
    private sessionModalService = inject(SessionModalService);
    private toastService = inject(ToastService);

    constructor() {
        this.init();
    }

    private init() {
        this.socketService.onEvent<SessionEvent>('auth:session').subscribe((event) => {
            console.log('Session event received:', event);
            if (event.type === 'EXPIRING_SOON') {
                this.sessionModalService.show(event.message, event.expires_at);
            } else if (event.type === 'LOGOUT_INIT') {
                this.toastService.warning('Your session has expired. Logging out...');
                this.authService.logout().subscribe();
            }
        });
    }
}
